import { instanceBo } from "../utils/axios.create";
import {
	CreatePayer,
	DeletePayer,
	PayerResponse,
	UpdatePayer,
} from "@/domain/payer.interface";

const findAll = async (): Promise<PayerResponse[]> => {
	return instanceBo
		.get("/payers")
		.then((res) => res.data.body)
		.catch((err) => {
			throw new Error(err.response.data);
		});
};

const createPayer = async (data: CreatePayer): Promise<PayerResponse> => {
	return instanceBo
		.post("/payers", data)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const updatePayer = async (data: UpdatePayer): Promise<PayerResponse> => {
	const { _id, ...updateData } = data;
	return instanceBo
		.put(`/payers/${_id}`, updateData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const deletePayer = async (data: DeletePayer): Promise<void> => {
	const { _id, ...deleteData } = data;
	return instanceBo
		.delete(`/payers/${_id}`, { data: deleteData })
		.then(() => undefined)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const payerService = {
	findAll,
	createPayer,
	updatePayer,
	deletePayer,
};
